import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { useAuth } from "@/context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Server-resolved per-feature access (mode + allow/deny lists live in the DB,
// so admins can change visibility without a deployment). Mirrors the
// conventions of useFeatureFlags: `loading` stays true while auth resolves.
export function useFeatureAccess(feature) {
  const { user, loading: authLoading } = useAuth();
  const [canAccess, setCanAccess] = useState(false);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (authLoading) return;
    if (!user) {
      setCanAccess(false);
      setLoading(false);
      return;
    }
    try {
      const res = await axios.get(`${API}/feature-access/${feature}`);
      setCanAccess(!!res.data?.can_access);
    } catch {
      setCanAccess(false);
    } finally {
      setLoading(false);
    }
  }, [feature, user, authLoading]);

  useEffect(() => { refresh(); }, [refresh]);

  return { canAccess, loading: loading || authLoading, refresh };
}
